module.exports={
    "database": {
        "host": "localhost",
        "username": "root",
        "password": "MaBou#95!",
        "name": "cardsender"
    },
    "email": {
        "mandrill-key": "2DqU1X13BOnIPnJavDt_mw",
        "sandbox": true
    },
    "base_key": "ruGAgoorrMhM8vxmZefQM3Dt*fqPsfmn",
    "localization": {
        "uriLanguage": true
    },
    "pillar": {
        "sites": {
            "public": "https://cardsender.sxt.com"
        },
        "livereload": false,
        "dev": true
    }
}